import React, { useState, useEffect } from 'react';
import TiltedCard from './components/TiltedCard';
import './CoordinatorsPage.css';
import './DevelopersPage.css';

const DevelopersPage = () => {
  const [loading, setLoading] = useState(true);
  const [visibleCards, setVisibleCards] = useState([]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setLoading(false);
    
    // Animate cards in sequence
    const timer = setTimeout(() => {
      developers.forEach((_, index) => {
        setTimeout(() => {
          setVisibleCards(prev => [...prev, index]);
        }, index * 200);
      });
    }, 300);
    
    return () => clearTimeout(timer);
  }, []);

  // Developers data - 8 members
  const developers = [
    { id: 1, name: 'Akiladithya R', title: 'UI/UX Engineer', image: '/coord/JOINT_TECH_HEAD2-AKILADITHYA_R.jpeg', linkedin: 'https://www.linkedin.com/in/akiladithya-r-070090293?utm_source=share_via&utm_content=profile&utm_medium=member_android', github: 'https://github.com/Akiladithya' },
    { id: 2, name: 'Balamurali S R', title: 'Product Engineer', image: '/coord/TECH_HEAD-BALAMURALI_S_R.jpg', linkedin: 'https://www.linkedin.com/in/baalaa06?utm_source=share_via&utm_content=profile&utm_medium=member_android', github: 'https://github.com/Baalaa06' },
    { id: 3, name: 'Dharani J M', title: 'Product Engineer', image: null, github: 'https://github.com/dharani123455678890' },
    { id: 4, name: 'Hareeshwar N K', title: 'Security & Compliance Engineer', image: '/faculty/HAREESH.png', linkedin: 'https://www.linkedin.com/in/hareeshwar-n-k/', github: 'https://github.com/Hareeshwar-N-K' },
    { id: 5, name: 'Harish Vardhan D', title: 'Product Engineer', image: '/coord/EVENT_COORDINATOR-HARISH_VARDHAN_D.jpeg', linkedin: 'https://www.linkedin.com/in/harishvardhan27?utm_source=share_via&utm_content=profile&utm_medium=member_android', github: 'https://github.com/harishvardhan27' },
    { id: 6, name: 'Janani K', title: 'Server-Side Engineer', image: '/coord/EVENT_COORDINATOR-JANANI_K.jpeg', linkedin: 'https://www.linkedin.com/in/janani-k-5a6b48328?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app', github: 'https://github.com/Jananii2611' },
    { id: 7, name: 'Kavin V K', title: 'Backend Engineer', image: '/faculty/KAVIN.jpeg', linkedin: 'https://www.linkedin.com/in/itzmekavinvk26/' },
    { id: 8, name: 'Vishal Madhav S', title: 'UI/UX Engineer', image: null, linkedin: 'https://www.linkedin.com/in/vishal-madhav-34a22028b/', github: 'https://github.com/manga-pannel-130' },
  ];

  if (loading) {
    return (
      <div className="coordinators-section">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Loading Developers...</p>
        </div>
      </div>
    );
  }

  return (
    <section className="coordinators-section developers-enhanced">
      <div className="floating-particles"></div>
      <div className="container">
        <div className="coordinators-section-wrapper">
          <div className="title-wrapper">
            <h2 className="section-title enhanced-title">Development Team</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle enhanced-subtitle">The Creative Minds Behind Cryptera 2K26's Digital Experience</p>
          </div>
          <div className="stats-banner">
            <div className="stat-item">
              <span className="stat-number">8</span>
              <span className="stat-label">Developers</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">1000+</span>
              <span className="stat-label">Hours Coded</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">50+</span>
              <span className="stat-label">Features Built</span>
            </div>
          </div>
          <div className="coordinators-grid enhanced-grid">
            {developers.map((developer, index) => (
              <div 
                key={developer.id} 
                className={`card-wrapper enhanced-card ${visibleCards.includes(index) ? 'visible' : ''}`}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="card-glow"></div>
                <div className={`tilted-card-container ${developer.title.toLowerCase().replace(' ', '-')}`}>
                <TiltedCard
                  imageSrc={developer.image || '/images/default-avatar.svg'}
                  altText={developer.name}
                  captionText={developer.name}
                  containerHeight="250px"
                  containerWidth="250px"
                  imageHeight="250px"
                  imageWidth="250px"
                  rotateAmplitude={15}
                  scaleOnHover={1.3}
                  showMobileWarning={false}
                  showTooltip={true}
                  displayOverlayContent={true}
                  overlayContent={
                    <div className="tilted-card-demo-text enhanced-overlay">
                      <p className="coordinator-name">{developer.name}</p>
                      <p className="coordinator-title">{developer.title}</p>
                      {developer.linkedin && (
                        <a 
                          href={developer.linkedin} 
                          target="_blank" 
                          rel="noopener noreferrer" 
                          className="linkedin-link"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <i className="fab fa-linkedin"></i>
                        </a>
                      )}
                      {developer.github && (
                        <a 
                          href={developer.github} 
                          target="_blank" 
                          rel="noopener noreferrer" 
                          className="github-link"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <i className="fab fa-github"></i>
                        </a>
                      )}
                      <div className="name-glow"></div>
                    </div>
                  }
                />
                </div>
              </div>
            ))}
          </div>
        {/*  
          <div className="tech-stack">
            <h3 className="tech-title">Technologies Used</h3>
            <div className="tech-icons">
              <span className="tech-icon">React</span>
              <span className="tech-icon">Firebase</span>
              <span className="tech-icon">CSS3</span>
              <span className="tech-icon">Responsive</span>
              <span className="tech-icon">Performance</span>
            </div>
          </div>
          */}
        </div>
      </div>
    </section>
  );
};

export default DevelopersPage;